import * as Yup from "yup";

export const LandingEnquiryFormSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, "Phone number must be 10 digits"),
  email: Yup.string().email("Invalid email")
  // location: Yup.object().nullable().required("Location is required"),
});

export const contactPageSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email"),
  mobile: Yup.string().required("Phone is required").matches(/^[0-9]{10}$/, "Must be exactly 10 digits")
    .required("Mobile number is required"),
  // location: Yup.object().required("Location is required"),
  // message: Yup.string().required("Message is required"),
});
